(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mr-tutorial-popup"] && !Shopify.designMode) return;
  try {
    (() => {
  const root = document.getElementById('MRFreeTutorial');
  if (!root || root.dataset.initialized === 'true') return;
  root.dataset.initialized = 'true';
  const dialog = root.querySelector('dialog');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const launcher = root.querySelector('[data-mrft-open]');
  const form = root.querySelector('form');
  const state = root.querySelector('[data-mrft-form-state]');
  const success = root.querySelector('[data-mrft-success]');
  const art = root.querySelector('[data-landscape]');
  const designMode = root.dataset.designMode === 'true';
  const prefix = 'mr-free-tutorial-v1-';
  const day = 86400000;
  let opened = false;
  let returnFocus = null;
  let timer = null;
  const read = (name, session = false) => {
    try { return (session ? window.sessionStorage : window.localStorage).getItem(prefix + name); } catch (_) { return null; }
  };
  const write = (name, value, session = false) => {
    if (designMode) return;
    try { (session ? window.sessionStorage : window.localStorage).setItem(prefix + name, String(value)); } catch (_) {}
  };
  const remove = (name, session = false) => {
    try { (session ? window.sessionStorage : window.localStorage).removeItem(prefix + name); } catch (_) {}
  };
  let subscribed = root.dataset.subscribed === 'true' || Number(read('subscribed-until')) > Date.now();
  const showView = confirmed => {
    form.hidden = confirmed;
    success.hidden = !confirmed;
    dialog.dataset.view = confirmed ? 'success' : 'signup';
    dialog.setAttribute('aria-labelledby', confirmed ? 'MRFreeTutorialSuccessTitle' : 'MRFreeTutorialTitle');
    dialog.setAttribute('aria-describedby', confirmed ? 'MRFreeTutorialSuccessDescription' : 'MRFreeTutorialDescription');
  };
  const open = (confirmed = subscribed, focusError = false) => {
    if (dialog.open) return;
    clearTimeout(timer);
    opened = true;
    returnFocus = document.activeElement;
    art.style.setProperty('--mrft-landscape', `url(${JSON.stringify(art.dataset.landscape)})`);
    showView(confirmed);
    dialog.showModal();
    document.documentElement.classList.add('mrft-modal-open');
    launcher.setAttribute('aria-expanded', 'true');
    const target = focusError ? root.querySelector('.mrft-error') : root.querySelector(confirmed ? '#MRFreeTutorialSuccessTitle' : '#MRFreeTutorialTitle');
    target?.focus({ preventScroll: true });
  };
  const close = () => dialog.close();
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('mrft-modal-open');
    launcher.setAttribute('aria-expanded', 'false');
    const repeatDays = Math.max(1, Math.min(30, Number(root.dataset.repeatDays) || 7));
    write('dismissed-until', Date.now() + repeatDays * day);
    const target = returnFocus?.isConnected && returnFocus !== document.body ? returnFocus : launcher;
    target.focus({ preventScroll: true });
  });
  root.querySelectorAll('[data-mrft-close]').forEach(button => button.addEventListener('click', close));
  launcher.addEventListener('click', () => open());
  let backdropPointer = false;
  dialog.addEventListener('pointerdown', event => { backdropPointer = event.target === dialog; });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog || !backdropPointer) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
  });
  form.addEventListener('submit', event => {
    if (designMode) {
      event.preventDefault();
      root.querySelector('[data-mrft-preview-message]').hidden = false;
      return;
    }
    if (!form.checkValidity()) return;
    write('pending', Date.now(), true);
  });
  const pending = Number(read('pending', true));
  const recentSubmission = pending > 0 && Date.now() - pending < 10 * 60000;
  const ownResponse = location.hash === '#MRFreeTutorialForm' || recentSubmission;
  launcher.hidden = false;
  launcher.setAttribute('aria-expanded', 'false');
  if (ownResponse && state.dataset.success === 'true') {
    subscribed = true;
    write('subscribed-until', Date.now() + 365 * day);
    remove('pending', true);
    open(true);
    return;
  }
  if (ownResponse && state.dataset.errors === 'true') {
    remove('pending', true);
    open(false, true);
    return;
  }
  if (pending && !recentSubmission) remove('pending', true);
  if (designMode) {
    if (root.dataset.editorPreview === 'true') open(false);
    return;
  }
  if (subscribed || Number(read('dismissed-until')) > Date.now()) return;
  const mobile = window.matchMedia('(max-width: 620px)').matches;
  if ((mobile ? root.dataset.autoMobile : root.dataset.autoDesktop) !== 'true') return;
  let interacted = false;
  let elapsed = false;
  const maybeOpen = () => {
    if (!elapsed || !interacted || opened || document.visibilityState !== 'visible') return;
    if (document.activeElement?.matches('input,textarea,select,[contenteditable="true"]')) return;
    const otherModal = Array.from(document.querySelectorAll('dialog[open],[aria-modal="true"],.drawer--is-open,.modal--is-active')).some(el => el !== dialog && el.getClientRects().length > 0);
    if (!otherModal) open(false);
  };
  const interact = () => { interacted = true; requestAnimationFrame(maybeOpen); };
  ['pointerdown', 'keydown', 'scroll'].forEach(name => window.addEventListener(name, interact, { once: true, passive: true }));
  const schedule = () => {
    const seconds = Math.max(0, Math.min(60, Number(root.dataset.delay) || 0));
    timer = window.setTimeout(() => { elapsed = true; maybeOpen(); }, seconds * 1000);
  };
  if (document.readyState === 'complete') schedule();
  else window.addEventListener('load', schedule, { once: true });
  document.addEventListener('visibilitychange', maybeOpen);
})();
  } catch(e) { console.error(e); }
})();

})();
